import { render, staticRenderFns } from "./searchScholarList.vue?vue&type=template&id=f1778974&scoped=true"
import script from "./searchScholarList.vue?vue&type=script&lang=js"
export * from "./searchScholarList.vue?vue&type=script&lang=js"
import style0 from "./searchScholarList.vue?vue&type=style&index=0&id=f1778974&scoped=true&lang=less"
import style1 from "./searchScholarList.vue?vue&type=style&index=1&id=f1778974&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1778974",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/gkzy/Desktop/achievement-transform-system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f1778974')) {
      api.createRecord('f1778974', component.options)
    } else {
      api.reload('f1778974', component.options)
    }
    module.hot.accept("./searchScholarList.vue?vue&type=template&id=f1778974&scoped=true", function () {
      api.rerender('f1778974', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/scholarSearch/comps/searchScholarList.vue"
export default component.exports